/* AD-06 · GUIDANCE REGISTRY & EMERGENCY
   ADM-06/07/08/16 + policy source register (§67): official text vs BMR
   inference distinguished; versioned, dated, reviewed. · Bible §20/§67 */
import { Note } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD06Guidance() {
  const rows = useAdmin().guidance
  return (
    <section data-frame="AD-06" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Guides destinations — registre</h2>
      <div className="tablewrap">
        <table className="tbl">
          <thead>
            <tr><th>Destination</th><th>Guide</th><th>Revu</th><th>Statut</th></tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.destination}>
                <td>{r.destination}</td>
                <td>{r.guide}</td>
                <td>{r.reviewed}</td>
                <td><Mark cell={r.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Note tone="candour">
        Changement de guide → écran d’impact : campagnes touchées, notifications,
        re-confirmations demandées, presets suggérés. Désactivation d’urgence : portée, motif,
        approbation, protection des cadeaux émis, retour arrière (DS-07 côté marchand).
      </Note>
    </section>
  )
}
